<template>
   
  <div style="height: 100vh">
    <div style="padding: 0 5px; margin: 0px; height: 100%">
      <!-- <div id="container" style="width: 100%;height:400px;" :center="center" :zoom="zoom" :events="events"></div> -->
      <el-amap
        id="container"
        vid="amapDemo"
        :center="center"
        :zoom="zoom"
        class="amap-demo"
        :events="events"
      >
        <el-amap-marker vid="marker" :position="center"> </el-amap-marker>
      </el-amap>
      <div class="col-12" style="height: 10px"></div>
      <!-- <input type="text" name="fname" class="left in" placeholder="" v-model="location"> -->
      <div v-if="location">{{ location }}</div>
      <div v-else>正在定位</div>
      <button @click="router(location, center)" class="ba">确认</button>
    </div>
    <div id="d_p"></div>
  </div>
</template>
<script>
import location from "./positionLocation";
export default {
  data() {
    let self = this;
    return {
      gender: "",
      // list: ['不显示位置', '台州市', '央钿大厦']
      center: [121.442874, 28.673348],
      location: "浙江省台州市椒江区海门街道台州市椒江区人民政府",
      lng: 0,
      lat: 0,
      zoom: 18,
      // address: "浙江省台州市路桥区路北街道央钿大厦",
      events: {
        click(e) {
          let { lng, lat } = e.lnglat;
          self.lng = lng;
          self.lat = lat;

          // 这里通过高德 SDK 完成。
          var geocoder = new AMap.Geocoder({
            radius: 1000,
            extensions: "all",
          });
          geocoder.getAddress([lng, lat], function (status, result) {
            if (status === "complete" && result.info === "OK") {
              if (result && result.regeocode) {
                console.log(result);
                self.address = result.regeocode.formattedAddress;
                self.location = result.regeocode.formattedAddress;
                self.lng = result.regeocode.crosses[0].location.lng;
                self.lat = result.regeocode.crosses[0].location.lat;

                // self.$nextTick();
              }
            }
          });
          self.center = [self.lng, self.lat];
        },
      },
    };
  },
  components: {},
  props: {},
  created() {
    if (this.$route.query.center1 != undefined) {
      this.location = this.$route.query.name;
      this.center = this.$route.query.center1;
    } else {
      ZWJSBridge.onReady(() => {
        console.log("onReady");
        ZWJSBridge.getLocation({})
          .then((res) => {
            console.log(res);
            this.location = res.detailAddress;
            let lat = res.latitude;
            let lon = res.longitude;
            this.center = lon.toString() + "," + lat.toString();
            this.center = this.center.split(",");
          })
          .catch((err) => {
            console.log(err);
          });
      }).catch(() => {
        console.log("onReadyErr");
      });
    }
  },
  mounted() {
    // console.log(this.$route.query.center1);
    // console.log(this.$route.query.name);
    // if (this.$route.query.center1 != undefined) {
    //   this.location = this.$route.query.name
    //   this.center = this.$route.query.center1
    // }
    // this.init()
    // this.getLocation()
    // if (this.$route.query.name != '所在位置') {
    //   this.gender = this.$route.query.name
    // }
  },
  methods: {
    getLocation() {
      let _that = this;
      let geolocation = location.initMap("icontainer"); // 定位
      AMap.event.addListener(geolocation, "complete", (result) => {
        console.log(result);
        // let { lng, lat } = result.position;
        _that.lat = result.position.lat;
        _that.lng = result.position.lng;
        _that.location = result.formattedAddress;
        _that.center = [_that.lng, _that.lat];
        console.log(_that.lat, _that.lng, _that.location);
      });
    },
    router(index, center) {
      if (this.$route.query.ro != undefined) {
        this.$router.push({
          name: "server_project_release",
          query: { name: index, center1: center },
        });
      } else {
        this.$router.push({
          name: "user_help_release",
          query: { name: index, center1: center },
        });
      }
    },
  },
};
</script>
<style>
.ba {
  height: 35px;
  width: 150px;
  border-radius: 3px;
  border: none;
  background: #01b2c2 !important;
  color: #fff;
  margin-left: 10px;
  cursor: pointer;
  margin-top: 25px;
}
.in {
  border-bottom: 1px solid #e0e0e0;
  padding: 0 10px;
  outline: none;
  height: 35px;
  width: 100%;
}
#container {
  height: 75%;
}
label {
  width: 100%;
  margin: 0;
}
.left {
  float: left;
  text-align: left;
}
.text {
  position: relative;
  padding: 0px 10px;
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #e0e0e0;
}
.right {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  margin: 0;
}
.amap-demo {
  /* width: 500px; */
  height: 500px;
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/location.vue